<template>
  <div class="main">
    <div class="header">
      <van-swipe
        v-if="adList.length"
        class="swiper"
        :autoplay="3000"
        @change="current = $event + 1"
      >
        <van-swipe-item v-for="(item, i) of adList" :key="i">
          <img :src="item" alt="" class="icon" />
        </van-swipe-item>
        <template #indicator>
          <div class="indicator">
            <div
              v-for="i of adList.length"
              :key="i"
              class="item"
              :class="{ active: current == i }"
            ></div>
          </div>
        </template>
      </van-swipe>
      <div class="yet">
        <div v-if="activity.images && activity.images.length" class="photo">
          <img
            v-for="(item, i) of activity.images"
            :key="i"
            :src="item"
            alt=""
            class="item"
          />
        </div>
        <span v-if="activity.join_type == 1" class="text"
          >已有{{ activity.join_value }}人正在参与销巴拼团</span
        >
        <span v-else class="text">人气值{{ activity.join_value }}</span>
      </div>
    </div>
    <div
      class="sticky"
      :style="{
        marginTop: adList.length ? '-1.2rem' : '0',
      }"
    >
      <div class="top">
        <img src="@/assets/groupBuy/gift.png" alt="" class="icon" />
        <div class="content">
          <span class="title">每日狂欢 销巴拼团更优惠</span>
          <span class="desc">价格直降·销巴臻选·品质保证</span>
        </div>
        <div class="btn" @click="$router.push(`/groupbuy/explain?id=${id}`)">
          <span>活动说明</span>
          <img src="@/assets/groupBuy/arrow.png" alt="" class="arrow" />
        </div>
      </div>
      <div
        class="countdown"
        :class="{ disabled: activity.activity_status != 2 }"
      >
        <span v-if="activity.activity_status == 1" class="label"
          >距开始还剩</span
        >
        <span v-else-if="activity.activity_status == 2" class="label"
          >距结束还剩</span
        >
        <span v-else class="label">活动已结束</span>
        <span class="item">{{ time("hour", 0) }}</span>
        <span class="item">{{ time("hour", 1) }}</span>
        <span class="item">{{ time("hour", 2) }}</span>
        <span class="divider">：</span>
        <span class="item">{{ time("minute", 0) }}</span>
        <span class="item">{{ time("minute", 1) }}</span>
        <span class="divider">：</span>
        <span class="item">{{ time("second", 0) }}</span>
        <span class="item">{{ time("second", 1) }}</span>
      </div>
      <div v-if="activity.collage" class="num">
        该专场单件商品成团人数：{{ activity.collage.group_size }}人
      </div>
    </div>
    <div class="body">
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        :error-text="errorText"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, i) of list" :key="i">
          <div class="icon">
            <img :src="item.image" alt="" class="img" />
            <div v-if="item.goods_status == 3" class="tip">已结束</div>
            <div v-if="item.goods_status == 4" class="tip" @click="showSellOut">
              已拼完
            </div>
          </div>
          <div class="info">
            <div class="title">
              <img src="@/assets/groupBuy/tag.png" alt="" class="tag" />
              <span>{{ item.goods_name }}</span>
            </div>
            <div v-if="item.join_type == 1" class="yet">
              已拼{{ item.join_value }}件
            </div>
            <div v-else class="moods">
              <img src="@/assets/groupBuy/fire.png" alt="" class="icon" />
              <span>人气值 {{ item.join_value }}</span>
            </div>
            <div v-if="item.goods_status == 2" v-html="renderDom(item)"></div>
            <div
              v-else
              class="btn"
              :class="{
                cancel: item.goods_status == 1,
                disabled: item.goods_status == 3 || item.goods_status == 4,
              }"
            >
              <div class="btn-item money">
                <div
                  :class="{
                    active: item.goods_status == 1 || item.goods_status == 2,
                  }"
                >
                  <span>￥</span>
                  <span class="large">{{ item.price }}</span>
                </div>
                <div>
                  <span>原价</span>
                  <span class="del">¥{{ item.origin_price }}</span>
                </div>
              </div>
              <div v-if="item.goods_status == 1" class="btn-item action">
                <span>预热中</span>
              </div>
              <div v-if="item.goods_status == 3" class="btn-item action">
                <span>已结束</span>
              </div>
              <div v-if="item.goods_status == 4" class="btn-item action">
                <span>已拼完</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getQuery } from "./utils";
import Utils from "@/providers/utils";
import banner from "@/assets/groupBuy/banner.png";

const arrow = require("@/assets/groupBuy/back.png");

export default {
  data() {
    return {
      id: null,
      adList: [],
      current: 1,
      timer: null,
      page: 0,
      loading: false,
      error: false,
      errorText: "发生异常",
      finished: false,
      activity: {},
      seconds: 0,
      list: [],
    };
  },
  mounted() {
    this.id = getQuery("id", location.href);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    this.$api
      .post("member/index/wechat/get/sign/package", {
        type: 1,
        url: location.href,
      })
      .then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ["checkJsApi"],
          openTagList: ["wx-open-launch-weapp"],
        });
      });
  },
  computed: {
    time() {
      return (type, index) => {
        let _temp = this.seconds;
        let hour = Math.floor(_temp / 60 / 60)
          .toString()
          .padStart(3, "0");
        _temp -= hour * 60 * 60;
        let minute = Math.floor(_temp / 60)
          .toString()
          .padStart(2, "0");
        _temp -= minute * 60;
        let second = _temp.toString().padStart(2, "0");
        switch (type) {
          case "hour":
            return hour.charAt(index);
          case "minute":
            return minute.charAt(index);
          case "second":
            return second.charAt(index);
          default:
            return 0;
        }
      };
    },
  },
  methods: {
    onLoad() {
      if (this.finished) {
        return;
      }
      this.$api
        .post("activity/index/group/buying/detail", {
          activity_id: this.id,
          page: ++this.page,
          size: 10,
        })
        .then((res) => {
          res.activity.images = res.activity.images.slice(0, 3);
          this.activity = res.activity;
          document.title = this.activity.name;
          if (this.activity.activity_status == 1) {
            // 预热中
            this.seconds = parseInt(
              (+Utils.date(this.activity.activity_start_at) - +Utils.date()) /
                1000
            );
          } else if (this.activity.activity_status == 2) {
            // 进行中
            this.seconds = parseInt(
              (+Utils.date(this.activity.activity_end_at) - +Utils.date()) /
                1000
            );
          } else {
            // return this.$router.replace("/groupbuy/finish");
          }
          let goods = res.goods;
          if (this.page == 1) {
            this.list = goods.data;
            this.getAds();
          } else {
            this.list = this.list.concat(goods.data);
          }
          this.finished = goods.current_page >= goods.last_page;
          this.startCountDown();
        })
        .catch(() => this.$router.replace("/groupbuy/finish"))
        .finally(() => (this.loading = false));
    },
    startCountDown() {
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(this.timer);
          this.seconds = 0;
          this.activity.activity_status = 3;
        }
      }, 1000);
    },
    getAds() {
      let tag = `shallyBuy_gb_second_top_${this.id}`;
      this.$api
        .post("adspace/index/get/ad/list", {
          labels: [tag],
        })
        .then((res) => {
          if (res[tag]) {
            this.adList = res[tag].map((_) => _.img_url);
            // 预热中、进行中添加广告默认图
            if (
              this.activity.activity_status == 2 ||
              this.activity.activity_status == 1
            ) {
              this.adList = this.adList.length ? this.adList : [banner];
            }
          }
        });
    },
    showSellOut() {
      this.$toast("该商品已拼完，请按售价单独购买");
    },
    renderDom(item) {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .btn { background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVwAAABYCAYAAAC58E+OAAAAAXNSR0IArs4c6QAAE7JJREFUeF7tnXuQXUWdx789d2YSJoSABBMmqEQFlcHaWkDXMbIWIJX1USiWlKVELRBRXHSF2i3KktINLMtSBhEplVpQIahQWqApMD5ACssIauGDmBUNICHmSSbJPDPv+9vqex73nD7dt/uce+65j/ndf5K5p7t/3Z8+53v7/PrX3QLKh1auGUCpfBkI5wN4OQFL1TT8NxNoOwJnHQHOmmy7anOF24zAHMpiqjSKLtqEfd13ibu2PRZtgQj+IJzWi/5lNxPhCgiU2qyZXF0mUJvABSPAiXNMiQkURkAAhMOlTfhzzzrxs60T0nBFcH2x3UzAeejtAda9G+LCtcBrVgNL+gqrIBtiAg0hMDsJuukNwPysVzz5VoLhRvC3ajwcjvgX1HzV0Yr3v6zp2b6+27PyTNsvDeYvjnRtxVO9b5ai6wlu/+BtBFyJlSdAbNwADJzSkPueC2UCTSHw7BbQPR+NmHZVWvVJVBVAfbKDv01KoV63PelsP36/tC9/MdL9Q3Hrny8U0mdLovwUFvWUxEN3stg2RRHYaCMJ0MM3A7+8o5EmuGwmUJOAIBB29JwraNXgLUT4DC59H8T1VzM2JtBxBOj2i4Ddf+q4dnGD2ouAmBB3C+of3EbAgHjwDuCMgfZqAdeWCdgITI2BbngTQPO2lEnfrprD5MO1l+yWwla+7bqbFXMqW/m262y/9ih3ojQsBXdUhn6J7Y/wBFm9Nwznbz0CTz8KuueTXr1C163Nh9ugZrB9DywtUP7zoizK/YOV3y2x+/EG3WVcLBNoHgH60Y3Alo1+BTJOQglfIExzXM7NY/txVI6TYB3EnwXX+WHhhO1IgG59D7D3r+1Yda5zBxJgwe3ATuUm+QQmDoOuWxMJvFUGurYBVr1xoKaOsPlC84r3Zft6Ak3kz4LL6tS5BLb+BHTPVRHfrdJUkyvRJrRpXQs2OzZPg+tCDVNPsn3fd9z8/mfB7Vy5WfAtowfWA4/fF+FgUx4LMuErXyiQtvJMSmpTWEM92L4inO3HnwV3wctS5wKgm94BvLijcxvILWs7Aiy4bddlXGEnAiP7QevPcUrKiZhAUQRYcIsizXaKJfDkg6DvXFN70kS9atsCIUhvS2eajAvy27ZQqDcd2699rzWRPwtusTLA1goiQPdeC/z6AZtT1rueEFDliUzEgaadNTNVwzfM9uOAqHP5s+AWJABsplgC9J/nA4f25GQ04yRXTtara45NQ+zcDBkK4vbHwdheIcz9wYLb6HuVyy+ewNAu0Pq1xdtli0zA9k7FS3v5Huk4Ao/fD/ru5/Nrli1QPj9L+pLYvt7102juQfk58ucRblGdxnYKI0DfugZ48qHkm7hag3rDOOtdIMH2vR5JG67suhLP5mpvAn8W3MJkgA0VQoAI9NlzgJED0e3BFNO2J00d2rj6TrMqh6n8tL5Ttq/3tabl0rj+Z8EtRAXYSGEE9v4NtP6CwsyxISaQhgALbhpanLb1CTx2L+jeG1q/nlzDBUmABXdBdnvnNppuvwr4/cP1NdA2SeLqQ8xaC7bvkctrN7e0/dBA/iy4aTuD07cuASqDrvpnYHxYX0fXBQxhunqXJKmuY3Ujc0P5bN8Dpy6ACHHalvoZbtEW6H8W3NaVD65ZWgI7/wJaf1HaXJyeCRRGgAW3MNRsqOEEfrYRdN8XzWayLhCyuRAa3TDbKy7bbyyBHPmz4Da2q7j0AgnQl68E/vgL/YbjUmy7hNkvWAkGTanIZeW117ZReMrijehsPwCuUW9Z+4bte+TSxmHL249XmmW96zhfSxGYnwf961uAyfFqtaLCI8W25Kh4UddqNIv6/RwpQfvqpit+VdKG0wYtsAXuG594v4B6hZftW25xiy9Zw58Ft6VUgyuTmcBzW0Hr15mzS7ENBFcrqPLpcFVaX2hn5RA3j09WRc7DtiyD7cdJOv4wZ8DPgpsBGmdpQQIP3gn63lfMFespea+AwUx1NGV0Nlx7PSJKlWdRAPNlYC4vwW1BnlylhhBgwW0IVi60aAL0P5cD236tNytFtLfbu1bLRaDm1r1SB/ln5oEyC27R/dzu9lhw270Huf7A7Azo8rcAM1MeDVUou7uAHl9wA15phFcnxJMz9sB8na16+sv1zd81Xdq6uJbrmm4B2mfBTdvpnL71CDz9JOi6S82b1SzqAbpLkXr7ihAKgx+9UPnb/7LiWlDT+S4J6U6Yms2wzVVQhcCG/zfZZrdMCpb2e7Yf+0UOsRfHnwW39eSDa5SSAH3/68D9t5tz9S0CuiL+hISwBsIXKaLWHNr0LDA7n7KWnJwJcFgY3wMdQIC+cAnwl9/rWyLDwfoWJ6+5uBRMPtyJKaBsjZnqALLchLwJ8Ag3b6JcXrEEpidBl5wNzMlXfGWkKkVV+m4X91avGV0FGg9BZVCsuBZkRMPYpFdeozdXsWk629ffa64LM2x3agP4s+DaoPP11ibw1BOg6z8RF8DogyJHtzIkrKKOFP4Tb5TBhxuWEylwdg44Mq1nYnIFmgi6prduZuMbcC0vqI9rerbvETNupuPOnwW3teWEa2chQN/+CvCDb5pTLVsSj73V+WZrjWTC9DKRAI5MATNz3C9MIBMBFtxM2DhTqxCga9YBz2zTV6fUBRyzJDGYTYSNBe4BdaGZToiHx+0jnVaBw/VoOQIsuC3XJVwhZwJHxkEfeitQNkQMSN/tksV+dJcytK01aWZa+ivdCaMTztXjhExAJcCCy/dE+xL47S9A//1v5tN55ei2t8drn9GV4LsKYq4Df7JM9dlJ3610KVj2LHEG6uxD9Uu0TQY5G3b3OYbs5H/YfvVeirK2Ta5F0rLgpr1JOX3LEKBvbAA2fUe/AEGK2fHLknsnqD5ZVYhNrZPpDo0Bc7rRtG1ple26yahrPls623W2ryfgys2WrnqdBbdl5IMrkpYAffr9wPPb9dlkONhxSw1RCYYRrG4kHJQu900YGklbRU7PBGIEWHD5hmhPAqPDoIvP1U9gyQHF0UcBR/cp7+KB0AZNjoxMZOhTzIWgOHknp4ER339rin9Vi7WlS0ve9EqvluOaju2nI+DKtUY6Ftx0yDl1qxDY8gjoxv/waqO7wV+yrOq/Nda5mrGqt/53lS8iGYfHACm6wSg4WmbaBzHIa1vC7yqkbF/fLyZ+TeTPgtsqAsL1SEWAvnoj8ND3lDy+gsl/Vi5PfWJOTV3ef1CznNfku7P59DQj7Jqtty0pq1dBbOjZvp5Q+v5nwbXda3y9JQnQx94L/H2Hvm6LeoHlywz11s+SCSFAppVEM7PA0LA5GsKZkKsQ639HtPHDzrajrwKqQFsKcY2msNaF28+Ca71JOEHLETh4APTBteZqHXN0csFDJbU2wFbzvfKOPjrO8bctdxO0Z4VYcNuz3xZ2rX++GXTTtVUGqg9zxfEO/tvoa72IhOl6cbmxObR9B4HZWXscqik+1/a9KY7Tlk/1TGRNz/b1z1NWnjX6hQV3YUtXW7aeNlwH/GRTpO4RxejqAl62wtiuRDCCjYDcbHz3fk9sw1frlCsfEq/kga/Zr3dC8Azv8Gzf661ww3ZV2Wp4kWIvOM3jz4Jre+D4essRoIvfBezboz/h4ajFwIqXONRZ58uNjmx9FRyf9Py3CZeE/CJtmIFDtWomST9JU6/FeH62H+eRvv9ZcPO9I7m0RhPYuxt08QVmKzIcTO4QZjgtUjoPqrIRCQsLPbmKf+LAIUCKLn+YQA4EWHBzgMhFFEhg8ybQF68zGzxpRQr/bbUYdbwb/r1jD5/OW2D3dropFtxO7+EOax/917XAwz/Wt6pUAlb3W1qcYvOEqWlg1/76Cbq6fF3Tpa2Ra7mu6dh+OgIRriy46dBx6iYToPf+CzA0pNTCdwMsXeIteEiEf1WdCJ5LIRke5smw8v3BEeDQcHUDHNNsvjVANq2vTzEUnrhggm+smJ+B7XsgXOOAG8efBbfJAsLmUxB44XnQuovMGWQ4WMJ/G02u89kG1/1wsOhjuXMvMDWTooKclAnUJsCCy3dI+xD4wfdBN99kru/qk4Debu11myMhcX2uDDy3s33YcE3bggALblt0E1ey8kL4uWuAx36uX4DQ3Q28+mVWUKpLwSjE8mSHPS/G30TVN3PXwPjoIDpaQ9f86sIO9W+1fLVctu/mUXDl6ppOvRvlGabl/sFKdrH7cevNygmYQNMIEIHecT4wEtnTIPBtSt/csUuBE09QqhddQVaR7PB6PDwsuBZJLxc7jIzHy0sIrvJFWLzJZ+pKz7bwwS8n2v5Y89i+XmGbz58F17UPOF1zCWzfDvrwxeY6rHqpJ7oJyY1OhqkCrBHaIP/wKCBXmaX9yBMhDo1odhbTFeQ6iZO2Eq7p2b7+F9WVX/p0LLjpmXGOZhC497ugL99itvya1UBPKTKCTbe5VzIOV41m8IpORjn4JqV2SZHeN5RNqJvBlG0WToAFt3DkbDALAbr6amDLL/VZF/VCnPoK32EQl06bkBoF1N/OxuTjrXwfDBCnZzx/70TGFWlZfYJZQNYaaLv6lPOyG5SzgNrPgpv3zcPl5U9gfh503tuAcYNP9fjjAOlS0BzOq1ZGG28b5jOFjRmWAJcJePEQIJf/SvW1hcMmyPgKFwqdX0BCgPwE6n69dS9UYPvhTVP5T+P5s+DmLw9cYt4Etm0DfeSSSKmK0pzcD3HsUq3exUaooWB5m9SEA6zKc+bH4Son60QtxfR07Aiwax8wPVtHa00KbVNSUxhC2qqwfT2xxvFnwU17j3L64gl8627QbV81Pxunnwp0d8VGmOo2jNUjyjwJTroa1PVpER9uVJfm54HdL3oTY/xhAikJsOCmBMbJiydAV3wKeOI3+jPK+hYDr12dmMyqCqrq040fpVM5Wif2Kumn1zlvpcjKcDEZiVDkx+TjLKoObN8jncOLBQtuUTct28lGYGYWdPZ5wNRUcvtZ+QCsWA6simw4HgplxEUQHaGqbstw8quaPu5qADA9DbywFxj3j0l3neSx+XRtk1SmqC22rxdAlUsL8mfBzSYDnKsoAr/7A+iSjxusCeDUVwDyDDP/o55uHosmkIOUqI828kBqv5c+330HgL1Dhi0aXX19FuUMikl7kkFiyGVT6JCS/x8/Pdv3eBTAnwW3KOFgO5kI0NfuAL5+pz6vVMkzXgd0dUE9dTd5Cq/vu5WCqx3xKqf2jk0Aci9cuUUjf5hATgRYcHMCycU0hgB95OPA7/6oL1xux/i6V3rutcox56EzwHc/+CvLwigENZ0/4o0qsJwU27nPC/XiDxPImQALbs5AubgcCUxOgQbf5p2YG/0EwnrSSkCe8OC7CkK5VV0FNf4Oi5UD4AOHgZ17gNm52o3gSSSPTw6TSJnuljbmz4Kbqcc5UyEEfvUb0GWf1pjyn/TTXw3IUW7gm40Ka5BLdSH438ficCenged3AcNjvpAYFhrE1DkqOErAvAmOSaASrle2X0GoLvToAP4suIUoBxvJQoC+9DXgfzfqd+ovdQFvfD2E6Eoc/6gV4DB6oRr2RXKlmIyplQsY5P+NJwKYJqOytKqiJErGcNYq5fdsPxuB5vFnwc3WY5yrAAJ00UeBrf+nt3TsMcDAq6pjnpgP13vbrT5W3kKHyrfBiHd0HHju78CRjPsfFNB+NtF5BFhwO69PO6NFY+OgN64F5CSW7nPyKgjpw615glkwKRYpYG4O2LHb29Ur749rfGzedoPy2L5Hwhbf3ET+LLiNgs/l1kfg0S2gy//dXMYZp0Ec3VcdsfopE27SqA9XRh7IUa06CWeykjVwPijP5imwEWL7tQnVGwbdBP4suDbofL0pBOiGW4Fv3qfY9hVIHqez5h/93WmjSeIBtuGSXXkQ5DM7gEOjfuK0SqYOIW1IbNP3bD+dknYOfxZc27PD15tCgN75YeDpZ/S2lx8HcfopNQ5D9324cpZbTohJF0KW0xua0nI22skEBPUPjhKwVGx/BFjS18lt5ba1C4HDI6Az324OCzr1ZIjo/gmxdnnTZSQnxf76PDB+pF1azfXsfAJlKbjbCBgQD94BnDHQ+U3mFrY+gc2Pgj75OXM9/+kfIJb0VXf58leaybhNkjt5ST+t3NUriOO0veGnJWILvM87ikytH9v3iDjHNaftYEv6jPwFiWFBqwZvIcJncOn7IK6/OueacXFMID0BunYDsPH+asbo5NOiXuDss5RnzXsCaP9BYPsOQB55kxj1VlIYvjbNbvnJ1cvGyRrbLBnb13fLwuAvQHcLWrlmgET5KSzqKYmH7gQGTkn/hHAOJpAjATrnA8CzL+hLPHE5IDccj2ghyQ1mnv4bMHQ4x1pwUUwgPwLeJnV0buWnhfoHbyPgSqw8AWLjBhbd/DhzSWkJ7B8CnXmBOdfAKRD++WUVj4Hc++DZneZ43bT2OT0TaAABIfBDseuJCz3BxWm96F+2mYDz0NsDrHs3xIVrAXn0NE+kNQA/F2kk8MBPQZ9a713WRU+99Q0QRy0GjY4B254B5DaK6sfmY3PFb4resvmE2b5H2MbJ1g8dwl8IbMXcxJvF/q0TIRJfdG8mwhUQKNlY8HUm0BACtUJUj1oMrDnTi6l9YU8yisH2gKddQm8SclPD2X7tW2KB8ffcCGITyuPrpNhqf4OkTxel8mUgnA/g5TJkrCEPFhfKBHQEtCt5fSVb2uedJyZ392rop9FhBrbKs/04IdsvmY1n2uv18KeygBiFoE1A6S6xb8tjUev/D23dlimbIY9GAAAAAElFTkSuQmCC); background-size: 100% 100%; background-repeat: no-repeat; width: 174px; height: 44px; display: flex; align-items: stretch; } .btn-item { padding: 0 12px; } .money { flex: 1; font-size: 10px; color: #999; display: flex; flex-direction: column; justify-content: center; align-items: center; white-space: nowrap; } .active { color: #fe0303; font-weight: 600; } .large { font-size: 18px; } .del { text-decoration: line-through; } .action { flex: 1; font-weight: 500; color: #fff; display: flex; justify-content: center; align-items: center; } .arrow { width: 12px; height: 12px; transform: rotateY(180deg); } .ellipsis { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } </style>";
      _script.text += `<div class="btn"> <div class="btn-item money"> <div class="active ellipsis"> <span>￥</span> <span class="large">${item.price}</span> </div> <div class="ellipsis"> <span>原价</span> <span class="del">¥${item.origin_price}</span> </div> </div> <div v-else class="btn-item action ellipsis"> <span>去拼团</span> <img src="${arrow}" alt="" class="arrow" /> </div> </div>`;
      let html = `<wx-open-launch-weapp id="launch-btn" class="btn" username="gh_d09812b9e2e1" path="pages/goods/detail/index.html?id=${item.goods_id}&fromPt=1" > ${_script.outerHTML} </wx-open-launch-weapp> `;
      return html;
    },
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  overflow: auto;
  font-size: 1.4rem;

  &::-webkit-scrollbar {
    width: 0 !important;
  }

  .nav {
    position: fixed;
    width: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    display: flex;
    align-items: stretch;
    height: 4rem;
    padding-top: var(--status-height);

    &-btn {
      flex: 0 0 4em;
      overflow: visible;
      display: flex;
      align-items: center;
      margin: 0 1.2rem;

      &.right {
        justify-content: right;
      }
    }

    &-title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1.8rem;
      font-weight: 500;
    }

    .back {
      width: 1.8rem;
      height: 1.8rem;
    }

    .share {
      width: 2.1rem;
      height: 2.1rem;
    }
  }

  .header {
    position: relative;

    .swiper {
      position: relative;

      .van-swipe-item {
        height: 18.1rem;

        .icon {
          width: 100%;
          height: 100%;
        }
      }

      .indicator {
        display: flex;
        position: absolute;
        right: 1.3rem;
        bottom: 2.3rem;

        .item {
          width: 1.2rem;
          height: 0.4rem;
          margin-left: 0.3rem;
          border-radius: 0.2rem;
          background: rgba(255, 255, 255, 0.7);

          &.active {
            background: #fff;
          }
        }
      }
    }

    .yet {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 2rem;
      padding: 0 1.3rem;

      .photo {
        display: flex;
        margin-right: 0.9rem;

        .item {
          width: 1.8rem;
          height: 1.8rem;
          border: 0.2rem solid #fff;
          border-radius: 100%;

          &:not(:first-of-type) {
            margin-left: -0.5rem;
          }
        }
      }

      .text {
        font-size: 1.2rem;
        color: #fff;
        font-weight: 500;
        line-height: 1.7rem;
      }
    }
  }

  .sticky {
    position: sticky;
    top: 0;
    z-index: 1;
    overflow: hidden;
    background: #fff;

    .top {
      flex: 0 0 5.8rem;
      display: flex;
      align-items: center;
      padding: 0.4rem 1.3rem 0;
      background-image: linear-gradient(180deg, #fefae7 0%, #ffffff 100%);
      border-radius: 1.2rem 1.2rem 0 0;
      position: relative;

      .icon {
        flex: 0 0 6.4rem;
        height: 4.9rem;
        margin-right: 0.8rem;
      }

      .content {
        display: flex;
        flex-direction: column;
        flex: 1;

        .title {
          font-size: 1.5rem;
          color: #a14c17;
          font-weight: 600;
        }

        .desc {
          font-size: 1.2rem;
          color: #963b07;
          letter-spacing: 0.1rem;
        }
      }

      .btn {
        flex: 0 0 7.2rem;
        height: 2.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        color: #943500;
        background: linear-gradient(90deg, #ffedd6 0%, #fee0bd 100%);
        // box-shadow: 0 -0.4rem 0.4rem 0 rgba(255, 215, 170, 0.74);
        border-radius: 1.2rem;

        .arrow {
          width: 1rem;
          height: 1rem;
        }
      }
    }

    .countdown {
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-weight: 500;
      padding: 0.8rem 0;

      &.disabled .item {
        background: #f5f6f7;
        color: #999999;
      }

      .label {
        color: #333;
        margin-right: 0.6rem;
      }

      .item {
        width: 1.5rem;
        height: 1.8rem;
        background: #ffecd4;
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #a14c17;
        margin: 0.1rem;
      }

      .divider {
        margin-left: 0.1rem;
      }
    }

    .num {
      width: 28.8rem;
      height: 1.9rem;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.06) 0%,
        rgba(248, 68, 38, 0.06) 19%,
        rgba(248, 68, 38, 0.06) 50%,
        rgba(248, 68, 38, 0.06) 80%,
        rgba(255, 255, 255, 0.06) 100%
      );
      border-radius: 0.6rem;
      font-size: 1.2rem;
      color: #f84426;
      letter-spacing: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 1.2rem;
    }
  }

  .list {
    .item {
      display: flex;
      padding: 0 1.6rem 0 1.2rem;
      margin-bottom: 1.2rem;

      & > .icon {
        position: relative;
        flex: 0 0 14rem;
        background: #f7fafa;
        height: 14.2rem;
        border-radius: 1rem;
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
        }

        .tip {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3.1rem;
          background: rgba(0, 0, 0, 0.38);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
      }

      .info {
        flex: 1;
        margin-left: 1.2rem;
        display: flex;
        flex-direction: column;
        align-items: stretch;

        .title {
          height: 4.8rem;
          font-size: 1.5rem;
          line-height: 2.4rem;
          font-weight: 500;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          .tag {
            width: 3.8rem;
            height: 1.6rem;
            vertical-align: text-bottom;
            margin-right: 0.5rem;
          }
        }

        .yet {
          font-size: 1rem;
          color: #999999;
          margin: 1.2rem 0;
        }

        .moods {
          align-self: flex-start;
          white-space: nowrap;
          margin: 1.2rem 0;
          padding: 0.2rem 0.3rem;
          background: #fee6dd;
          border-radius: 0.2rem;
          font-size: 1.1rem;
          color: #ff3800;
          display: flex;
          align-items: center;

          .icon {
            width: 1rem;
            height: 1.3rem;
            margin-right: 0.1rem;
          }
        }

        .btn {
          background-image: url(~@/assets/groupBuy/btn-bg.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          width: 17.4rem;
          height: 4.4rem;
          display: flex;
          align-items: stretch;

          &.disabled {
            background-image: url(~@/assets/groupBuy/btn-bg--disabled.png);
            pointer-events: none;
          }

          &.cancel {
            background-image: url(~@/assets/groupBuy/btn-bg--cancel.png);
          }

          &-item {
            padding: 0 1.2rem;
            overflow: hidden;
          }

          .money {
            flex: 1;
            font-size: 1rem;
            color: #999;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;

            & > div {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .active {
              color: #fe0303;
              font-weight: 600;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .large {
              font-size: 1.8rem;
            }

            .del {
              text-decoration: line-through;
            }
          }

          .action {
            flex: 1;
            font-weight: 500;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;

            .arrow {
              width: 1.2rem;
              height: 1.2rem;
              transform: rotateY(180deg);
            }
          }
        }
      }
    }
  }
}
</style>
